import { getRequest, postRequest } from "./ApiRequest";

// Import di vini da CSV/Excel. GET = modello CSV (testo), POST multipart {file, dry_run}.
export const DatasetImport = {
  template: () => getRequest("admin/winedata/import"),
  run: (formData) => postRequest("admin/winedata/import", formData),
};
export const CardImport = {
  template: () => getRequest("menucard/wines/import"),
  run: (formData) => postRequest("menucard/wines/import", formData),
};
